var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15671_11559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2496 10.8949C28.6588 9.00405 26.7493 0.658194 18.6337 0.658203C16.6561 0.658203 12.2643 1.71447 10.5184 5.93955C7.69025 4.89606 4.92625 7.13927 4.92625 10.8949C3.85784 11.2209 1.65288 11.2321 1.65283 14.7418C1.65279 18.2515 4.40336 18.2192 5.81272 18.5235H28.2496C31.4263 18.0208 32.2378 10.8949 28.2496 10.8949Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7895 22.4974L19.4114 18.4844H14.8537L12.1967 23.2465H14.2939L11.604 29.9267L18.6461 22.4974H16.7895Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10192 19.0249C7.60176 19.2598 7.81652 19.8554 7.58161 20.3553L6.64019 22.3584C6.40528 22.8582 5.80965 23.073 5.30981 22.8381C4.80998 22.6032 4.59521 22.0076 4.83012 21.5077L5.77155 19.5046C6.00646 19.0047 6.60209 18.79 7.10192 19.0249ZM4.27765 25.0343C4.77748 25.2692 4.99225 25.8649 4.75734 26.3647L3.81591 28.3678C3.581 28.8677 2.98537 29.0824 2.48554 28.8475C1.9857 28.6126 1.77094 28.017 2.00585 27.5172L2.94727 25.514C3.18218 25.0142 3.77781 24.7994 4.27765 25.0343Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1019 19.0249C11.6018 19.2598 11.8165 19.8554 11.5816 20.3553L10.6402 22.3584C10.4053 22.8582 9.80965 23.073 9.30981 22.8381C8.80998 22.6032 8.59521 22.0076 8.83012 21.5077L9.77155 19.5046C10.0065 19.0047 10.6021 18.79 11.1019 19.0249ZM8.27765 25.0343C8.77748 25.2692 8.99225 25.8649 8.75734 26.3647L7.81591 28.3678C7.581 28.8677 6.98537 29.0824 6.48554 28.8475C5.9857 28.6126 5.77094 28.017 6.00585 27.5172L6.94727 25.514C7.18218 25.0142 7.77781 24.7994 8.27765 25.0343Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0507 19.0249C24.5505 19.2598 24.7653 19.8554 24.5303 20.3553L23.5889 22.3584C23.354 22.8582 22.7584 23.073 22.2585 22.8381C21.7587 22.6032 21.5439 22.0076 21.7789 21.5077L22.7203 19.5046C22.9552 19.0047 23.5508 18.79 24.0507 19.0249ZM21.2264 25.0343C21.7262 25.2692 21.941 25.8649 21.7061 26.3647L20.7646 28.3678C20.5297 28.8677 19.9341 29.0824 19.4343 28.8475C18.9344 28.6126 18.7197 28.017 18.9546 27.5172L19.896 25.514C20.1309 25.0142 20.7265 24.7994 21.2264 25.0343Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1708 18.5233H23.6992C24.0074 18.5233 24.4074 18.4632 24.8816 18.353C30.4907 17.0496 28.5324 9.91351 22.7429 9.91351C21.4315 3.35258 12.7991 5.29326 12.1328 9.91351C6.50258 10.4436 5.04654 18.5233 10.1708 18.5233Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15671_11559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorm);
export default __webpack_public_path__ + "static/media/storm.61508000e4a46fd3609cfbac963aa889.svg";
export { ForwardRef as ReactComponent };